<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col">
                    <h2>{{ title }}</h2>
                </div>
                <div class="col text-right">
                    <button @click.prevent="clear"
                            class="btn btn-primary">Pulisci
                    </button>
                    <button @click.prevent="search"
                            class="btn btn-success">Cerca
                    </button>
                </div>
            </div>

            <company-card-form :form="form" type="search"/>

        </div>
    </section>
</template>

<script>
import CompanyCardForm from "../components/CompanyCardForm";
import sharedState from "../sharedState";
import companyCards from "../services/api/companyCards";

export default {
    name: "AdvancedSearchCompanyCard",
    components: {CompanyCardForm},
    data() {
        return {
            sharedState: sharedState,
            title: 'Ricerca avanzata schede aziende',
            peopleCardId: null,
            form: new Form()
        }
    },
    methods: {
        async search() {
            this.$isLoading(true)
            let response = await companyCards.advancedSearch(this.form)
            let ts = Date.now()
            sharedState.pushAdvancedSearchResults({
                ts: ts,
                type: 'companies',
                ids: response.data.data.ids,
                searchKeys: response.data.data.searchKeys
            })
            this.$isLoading(false)
            await this.$router.push({path: '/advanced-search/company-cards/results/' + ts});
        },
        clear() {
            this.form = new Form()
        }
    }
}
</script>

<style scoped>

</style>
